import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";


import { Box } from "@mui/material";

export default function Layout({ children }) {
  return (

    <>
    <Header/>
    <Box sx={{ maxWidth: "100%", pt: 0 }} className="main-content">
      {children}
    </Box>
    <Footer/>
    </>
    

  );
}
